import { useTranslation } from 'react-i18next'
import { shallowEqual, useSelector } from 'react-redux'
import { format } from 'date-fns'

import { Button } from '@mui/material'
import { dateTimeTableFormat } from '@/constants/date'
import {
  useTransactions,
  useTransactionsFilters,
  useTransactionsActions,
} from '@/views/transactions/hooks'

import { TransactionWalletsLibraryColumnProps } from '@/state/transactions/models'
import { transactionsSelector } from '@/state/transactions/slices/index.slices'
import { BonusType } from '@/enums'

import { TableGenericComponent } from '@/views/components'
import { TransactionsTableStandardRow, TransactionsTableFreePlaysRow } from './'

export const TransactionTableComponent = () => {
  const { t } = useTranslation()

  const {
    isLoading,
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
    pagination,
    getXlsFormattedRow,
  } = useTransactions()

  const { getAllTransactions } = useTransactionsActions()

  const { handleChangePage, handleChangeLimit } = useTransactionsFilters()

  const { filters } = useSelector(transactionsSelector, shallowEqual)

  const body = sortedRows.map((row: TransactionWalletsLibraryColumnProps) => {
    return <TransactionsTableStandardRow key={row.id} row={row} />

    // return filters.walletType === BonusType.FREE_PLAY ? (
    //   <TransactionsTableFreePlaysRow key={row.id} row={row} />
    // ) : (
    //   <TransactionsTableStandardRow key={row.id} row={row} />
    // )
  })

  const fileName = `transactions-wallets-${format(
    new Date(),
    dateTimeTableFormat,
  )}`

  const xlsxButton = (
    <Button
      onClick={() =>
        getAllTransactions(
          {
            ...filters,
            page: 1,
            limit: 999999,
            xlsx: true,
          },
          headCells,
          fileName,
          getXlsFormattedRow,
        )
      }
      variant="contained"
    >
      {t('labels.downloadAsXLS')}
    </Button>
  )

  return (
    <TableGenericComponent<TransactionWalletsLibraryColumnProps>
      order={order}
      orderBy={orderBy}
      headCells={headCells}
      rowLength={sortedRows.length}
      pagination={pagination}
      isLoading={isLoading}
      body={body}
      hasAction={false}
      // hasAction={filters.walletType === BonusType.FREE_PLAY}
      leftContent={xlsxButton}
      createSortHandler={createSortHandler}
      handleChangePage={handleChangePage}
      handleChangeLimit={handleChangeLimit}
    />
  )
}
